module.exports = __webpack_public_path__ + "img/phone.db2d0e5d.svg";